var checkIsFunction = function (func) {
    return func && typeof func === "function";
};

export { checkIsFunction };
//# sourceMappingURL=function.js.map
